import { IKeyExpressionCategory } from '../../../../model/feedback.interface'
import { n_lesson_review } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import KeyExpressionCard from './KeyExpressionCard'

const WhatYouCanImprove = ({ list = [], pronunciation = '', tutorName = 'Ringle' }) => {
  const { t } = useTranslation()
  return (
    <div className="mt-[40px] flex w-full flex-col items-start justify-start">
      <div className="text-[20px] font-bold text-gray-800">What you can improve</div>
      <div className="mt-[4px] font-[14px] text-gray-500">{t(n_lesson_review.feedback_section_detail3)}</div>
      <div className="mt-[24px] w-full">
        {list.map((item, i) => {
          const { answers, title } = item
          return answers.map((answer) => {
            const { wrong_content, right_content, key_expressions, content } = answer
            return (
              <KeyExpressionCard
                title={title}
                before={wrong_content}
                after={right_content}
                tutorsComment={content}
                key={`${item.title}${i}`}
                tutorName={tutorName}
                keyExpressions={key_expressions}
              />
            )
          })
        })}
        {pronunciation && (
          <KeyExpressionCard title={IKeyExpressionCategory[4]} tutorsComment={pronunciation} tutorName={tutorName} />
        )}
      </div>
    </div>
  )
}

export default WhatYouCanImprove
